/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_History_ErrorInputs */

const en_us2_plan_history_error = /** @type {(inputs: Plan_History_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The history could not be loaded.`)
};

const pt_br2_plan_history_error = /** @type {(inputs: Plan_History_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o histórico.`)
};

const es_419_plan_history_error = /** @type {(inputs: Plan_History_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el historial.`)
};

const pt_pt2_plan_history_error = /** @type {(inputs: Plan_History_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o histórico.`)
};

const fr_fr2_plan_history_error = /** @type {(inputs: Plan_History_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger l'historique.`)
};

const de_de2_plan_history_error = /** @type {(inputs: Plan_History_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Verlauf konnte nicht geladen werden.`)
};

const it_it2_plan_history_error = /** @type {(inputs: Plan_History_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non è stato possibile caricare lo storico.`)
};

/**
* | output |
* | --- |
* | "The history could not be loaded." |
*
* @param {Plan_History_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_history_error = /** @type {((inputs?: Plan_History_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_History_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_history_error(inputs)
	if (locale === "es-419") return es_419_plan_history_error(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_history_error(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_history_error(inputs)
	if (locale === "de-DE") return de_de2_plan_history_error(inputs)
	if (locale === "it-IT") return it_it2_plan_history_error(inputs)
	return en_us2_plan_history_error(inputs)
});
export { plan_history_error as "plan.history_error" }